import ConfigForm, {
  ConfigInput,
  FormOption,
} from "components/Layout/ConfigForm";
import React from "react";

export interface LogbookItemAdderProps {
  textOptions: FormOption[];
  photoOptions: FormOption[];
  signatureOptions: FormOption[];
  barcodeOptions: FormOption[];
  onTextOptionAdd: (option: FormOption) => void;
  onTextOptionRemove: (option: FormOption) => void;
  onTextOptionEdit: (option: FormOption) => void;
  onPhotoOptionAdd: (option: FormOption) => void;
  onPhotoOptionEdit: (option: FormOption) => void;
  onPhotoOptionRemove: (option: FormOption) => void;
  onSignatureOptionAdd: (option: FormOption) => void;
  onSignatureOptionEdit: (option: FormOption) => void;
  onSignatureOptionRemove: (option: FormOption) => void;
  onBarcodeOptionAdd: (option: FormOption) => void;
  onBarcodeOptionRemove: (option: FormOption) => void;
  onBarcodeOptionEdit: (option: FormOption) => void;
}

export default function LogbookItemAdder({
  barcodeOptions,
  signatureOptions,
  photoOptions,
  textOptions,
  onTextOptionEdit,
  onTextOptionRemove,
  onTextOptionAdd,
  onPhotoOptionEdit,
  onPhotoOptionRemove,
  onPhotoOptionAdd,
  onSignatureOptionEdit,
  onSignatureOptionRemove,
  onSignatureOptionAdd,
  onBarcodeOptionEdit,
  onBarcodeOptionRemove,
  onBarcodeOptionAdd,
}: LogbookItemAdderProps) {
  const inputs: ConfigInput[] = [
    {
      title: "Add Text Inputs",
      type: "addList",
      options: textOptions,
      xs: 12,
      sm: 6,
      id: "addTextInputs",
      onChange: () => {},
      onOptionAdd: onTextOptionAdd,
      onOptionEdit: onTextOptionEdit,
      onOptionRemove: onTextOptionRemove,
    },
    {
      title: "Add Photo Inputs",
      type: "addList",
      options: photoOptions,
      xs: 12,
      sm: 6,
      id: "addPhotoInputs",
      onChange: () => {},
      onOptionAdd: onPhotoOptionAdd,
      onOptionEdit: onPhotoOptionEdit,
      onOptionRemove: onPhotoOptionRemove,
    },
    {
      title: "Add Signature Inputs",
      type: "addList",
      options: signatureOptions,
      xs: 12,
      sm: 6,
      id: "addSignatureInputs",
      onChange: () => {},
      onOptionAdd: onSignatureOptionAdd,
      onOptionEdit: onSignatureOptionEdit,
      onOptionRemove: onSignatureOptionRemove,
    },
    {
      title: "Add Barcode Inputs",
      type: "addList",
      options: barcodeOptions,
      xs: 12,
      sm: 6,
      id: "addBarcodeInputs",
      onChange: () => {},
      onOptionAdd: onBarcodeOptionAdd,
      onOptionEdit: onBarcodeOptionEdit,
      onOptionRemove: onBarcodeOptionRemove,
    },
  ];
  return <ConfigForm title="Add Logbook Inputs" inputs={inputs} />;
}
